window.updateShippingProgress = function() {
  const threshold = 12000; // $120 in cents
  const progressContainer = document.querySelector('.cart-drawer__shipping-progress');
  
  if (!progressContainer) {
    console.log('Progress container not found');
    return;
  }
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const currentTotal = cart.total_price;
      const remaining = threshold - currentTotal;
      const progressPercentage = Math.min((currentTotal / threshold) * 100, 100);
      
      console.log('Cart Total: $' + (currentTotal/100).toFixed(2));
      console.log('Progress: ' + progressPercentage.toFixed(1) + '%');
      
      let html = '<div class="shipping-progress-content">';
      
      if (currentTotal === 0) {
        html += '<p class="shipping-progress__text shipping-progress__text--promo">Free shipping for orders over $120.00!</p>';
      } else if (remaining > 0) {
        const remainingDollars = (remaining / 100).toFixed(2);
        html += `<p class="shipping-progress__text">You're only $<span class="remaining-amount">${remainingDollars}</span> away from Free Shipping</p>`;
        html += `<div class="shipping-progress__bar" style="width: 100%; height: 10px; background-color: #e0e0e0; border-radius: 5px; overflow: hidden; margin-top: 8px;">`;
        html += `<div class="shipping-progress__bar-fill" style="width: ${progressPercentage}%; height: 100%; background-color: #4caf50; transition: width 0.3s ease;"></div>`;
        html += `</div>`;
      } else {
        html += '<p class="shipping-progress__text shipping-progress__text--success">✓ You qualify for free shipping!</p>';
        html += `<div class="shipping-progress__bar" style="width: 100%; height: 10px; background-color: #e0e0e0; border-radius: 5px; overflow: hidden; margin-top: 8px;">`;
        html += `<div class="shipping-progress__bar-fill" style="width: 100%; height: 100%; background-color: #4caf50; transition: width 0.3s ease;"></div>`;
        html += `</div>`;
      }
      
      html += '</div>';
      progressContainer.innerHTML = html;
    })
    .catch(error => console.error('Error updating shipping progress:', error));
};

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.updateShippingProgress);
} else {
  window.updateShippingProgress();
}

// Listen for cart updates
document.addEventListener('cart:updated', window.updateShippingProgress);

// Listen for quantity changes
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name="updates[]"]') || e.target.matches('.quantity__input')) {
    setTimeout(window.updateShippingProgress, 800);
  }
});

// Listen for button clicks
document.addEventListener('click', function(e) {
  if (e.target.closest('.quantity__button') || e.target.closest('[name="update"]')) {
    setTimeout(window.updateShippingProgress, 800);
  }
});

// Watch for cart section updates
setInterval(function() {
  const progressBarFill = document.querySelector('.shipping-progress__bar-fill');
  if (!progressBarFill && document.querySelector('.cart-drawer__shipping-progress')) {
    window.updateShippingProgress();
  }
}, 1000);
